import { graphql } from 'gatsby';
import Img from 'gatsby-image';
import React from 'react';
export default {
  graphql,
  Img,
  React
};